// ══════════════════════════════════════════════════════════════════════
// illustrative.ts — the SINGLE labelled illustrative/sample demo fixture for
// the value-proven dashboard (029-value-proven-dashboard, FR-003).
//
// THIS IS ILLUSTRATIVE / SAMPLE DEMO DATA — NOT measured fact. The loop
// (E2–E6) that would produce real forecasts, measurements, adoption, and a
// real calibration record is NOT built; the figures below exist only so the
// dashboard can convey the full five-element concept HONESTLY. Every figure
// sourced from here is marked with the `illustrative` provenance and badged in
// the UI; none of it is ever passed off as real/measured.
//
// DETERMINISM (load-bearing, plan §Honesty & determinism, SC-007): everything
// here is a STATIC LITERAL. NO Math.random, NO Date.now, NO clock — so the pure
// projection `deriveValueProven` stays deterministic (equal input → deeply-equal
// output / golden-masterable). `deriveValueProven` reads its illustrative numbers
// ONLY from this module, never from the real readers (vision.ts / scope.ts).
// ══════════════════════════════════════════════════════════════════════

// ── The two illustrative headline measures (FR-006). Progress-to-vision is REAL
// and is NOT here; these two have no real source by design (E2–E6 unbuilt).
export const ILLUSTRATIVE_FORECAST_ACCURACY = 72; // % — illustrative trend
export const ILLUSTRATIVE_VALUE_REALISATION = 0.58; // ratio 0..1 — illustrative

// ── The expected / speculative band money + traceable-assumption strings
// (FR-007/FR-008). Proven is REAL-empty (money null) and is NOT here.
export const ILLUSTRATIVE_EXPECTED_MONEY = 1_200_000;
export const ILLUSTRATIVE_EXPECTED_ASSUMPTION =
  'Assumes the in-flight streams realise their predicted ranges at current adoption.';
export const ILLUSTRATIVE_SPECULATIVE_MONEY = 3_400_000;
export const ILLUSTRATIVE_SPECULATIVE_ASSUMPTION =
  'Assumes every candidate stream is delivered and adopted at the modelled ceiling.';

// ── The per-row loop columns (FR-009). One illustrative column-set the row
// projection reads for each REAL area; `null` reads as "—" (un-sized), never 0.
export type IllustrativeStreamColumns = {
  stage: string | null;
  baseline: number | null;
  predictedRange: string | null;
  delivery: string | null;
  realised: number | null;
  adoption: number | null;
};

export const ILLUSTRATIVE_STREAM_COLUMNS: IllustrativeStreamColumns = {
  stage: 'As-is mapped',
  baseline: 480_000,
  predictedRange: '£0.4m – £0.9m',
  delivery: 'Scoping',
  realised: null,
  adoption: null,
};

// ── The illustrative calibration series (FR-011): predicted-vs-realised over
// time for one wedge's worth. Static `at` labels (NO clock).
export type IllustrativeCalibrationPoint = {
  predicted: number;
  realised: number;
  at: string;
};

export const ILLUSTRATIVE_CALIBRATION: IllustrativeCalibrationPoint[] = [
  { predicted: 120_000, realised: 96_000, at: 'Q1' },
  { predicted: 240_000, realised: 220_000, at: 'Q2' },
  { predicted: 360_000, realised: 350_000, at: 'Q3' },
  { predicted: 480_000, realised: 470_000, at: 'Q4' },
];
